// extracted by mini-css-extract-plugin
export var bodySections = "_bd-8";
export var gray = "_bd-7";
export var green = "_bd-4";
export var iconContainer = "_bd-9";
export var iconWidgetContainer = "_bd-1";
export var phoneIcon = "_bd-2";
export var red = "_bd-5";
export var statusDot = "_bd-3";
export var widgetContainer = "_bd-0";
export var yellow = "_bd-6";